// @flow
import {
    GRAPH_LIST,
    GRAPH_LIST_SUCCESS,
    GRAPH_LIST_FAILED,

} from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

const INIT_STATE = {
    user: getLoggedInUser(),
    loading: false,
};

type GraphAction = { type: string, payload: {} | string };
type State = { user?: {} | null, loading?: boolean, +value ?: boolean };

const Graph = (state: State = INIT_STATE, action: GraphAction) => {
    switch (action.type) {
        case GRAPH_LIST:
            return { ...state, listloading: true };
        case GRAPH_LIST_SUCCESS:
            return { ...state, graph: action.payload, listloading: false, error: null };
        case GRAPH_LIST_FAILED:
            return { ...state, error: action.payload, loading: false };
    
        default:
            return { ...state };
    }
};

export default Graph;
